import React from 'react';

export default function ModalBoasVindas({ onFechar }) {
  return (
    <>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(40px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        .boas-vindas-card { animation: slideUp 0.4s ease-out forwards; }
      `}</style>

      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 overflow-y-auto">
        <div className="boas-vindas-card bg-slate-900 border border-orange-500/30 rounded-2xl shadow-2xl max-w-lg w-full my-4">

          {/* Header */}
          <div className="bg-gradient-to-r from-orange-600 to-yellow-500 rounded-t-2xl p-6 text-center">
            <div className="text-5xl mb-2">🎮</div>
            <h1 className="text-white text-2xl font-extrabold tracking-wide">BEM-VINDO AO JOGO!</h1>
            <p className="text-orange-100 text-sm mt-1">Aqui, bater meta tem recompensa real.</p>
          </div>

          {/* Regras */}
          <div className="p-6 space-y-5">

            {/* Meta diária */}
            <div className="bg-slate-800 rounded-xl p-4 space-y-2 border border-slate-700">
              <div className="flex items-center gap-2">
                <span className="text-2xl">🏅</span>
                <h2 className="text-white font-bold text-base">Meta Diária</h2>
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">
                O <strong className="text-orange-400">primeiro</strong> a bater a meta do dia leva um <strong className="text-yellow-400">prêmio surpresa</strong>!
                Só um vendedor ganha por dia — então não perca tempo!
              </p>
              <p className="text-slate-500 text-xs">✅ Sem limite de horário — vale o dia todo.</p>
            </div>

            {/* Meta semanal */}
            <div className="bg-slate-800 rounded-xl p-4 space-y-2 border border-slate-700">
              <div className="flex items-center gap-2">
                <span className="text-2xl">🏆</span>
                <h2 className="text-white font-bold text-base">Meta Semanal</h2>
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">
                Bata a meta da semana até <strong className="text-orange-400">quarta-feira</strong> e ganhe um prêmio especial!
                Só o <strong className="text-yellow-400">primeiro</strong> a conseguir leva.
              </p>
              <p className="text-slate-500 text-xs">⏰ Bateu depois da quarta? Parabéns pelo resultado, mas o prêmio fica para a próxima!</p>
            </div>

            {/* Meta mensal */}
            <div className="bg-slate-800 rounded-xl p-4 space-y-2 border border-slate-700">
              <div className="flex items-center gap-2">
                <span className="text-2xl">🌟</span>
                <h2 className="text-white font-bold text-base">Meta Mensal</h2>
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">
                Bata a meta do mês até o <strong className="text-orange-400">final da terceira semana</strong> do mês.
                Apenas o <strong className="text-yellow-400">primeiro</strong> a chegar lá conquista o prêmio!
              </p>
              <p className="text-slate-500 text-xs">⏰ Bateu depois? A conquista é sua, mas o prêmio não.</p>
            </div>

            {/* Prêmios */}
            <div className="bg-orange-500/10 border border-orange-500/20 rounded-xl p-4 space-y-1">
              <p className="text-orange-300 font-semibold text-sm">🎁 Os prêmios são SURPRESA!</p>
              <p className="text-slate-400 text-xs">Você só descobre o que ganhou quando bater a meta. Mantém a emoção!</p>
            </div>

            {/* Regras de uso */}
            <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-4 space-y-1.5">
              <p className="text-slate-300 text-xs font-semibold uppercase tracking-widest mb-2">📋 Regras de uso dos prêmios</p>
              <p className="text-slate-400 text-xs">🗓️ Cada prêmio vale até o <strong>último dia do mês corrente</strong>.</p>
              <p className="text-slate-400 text-xs">🚫 Prêmios <strong>não são cumulativos</strong> — não acumulam para o mês seguinte.</p>
              <p className="text-slate-400 text-xs">⚡ Uma vez conquistado, o prêmio daquele período não pode ser ganho por mais ninguém.</p>
              <p className="text-slate-400 text-xs">🏅 Por período, apenas <strong>1 ganhador</strong> por dia/semana/mês.</p>
            </div>

          </div>

          {/* Footer */}
          <div className="px-6 pb-6">
            <button
              onClick={onFechar}
              className="w-full bg-gradient-to-r from-orange-600 to-yellow-500 hover:from-orange-700 hover:to-yellow-600 text-white font-bold py-3.5 rounded-xl transition-all text-base tracking-wide shadow-lg"
            >
              🚀 ENTRAR NO JOGO!
            </button>
            <p className="text-slate-600 text-xs text-center mt-3">Boa sorte! Que vença o melhor 💪</p>
          </div>

        </div>
      </div>
    </>
  );
}
